<template>
  <div
    :class="{ 'pis__stage--full': $page.props.settings.application_mode === 'player' }"
    class="pis__stage"
  >
    <div
      v-if="$page.props.settings.application_logo"
      class="pis__logo"
    >
      <img src="/img/tapaz-logo.png" alt="">
    </div>
    <video ref="player"
           muted
           playsinline
           controls
    />

    <div v-if="false" class="pis__loader">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24">
        <title>{{ title }}</title>
        <g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#ffffff" stroke="#ffffff">
          <g class="nc-loop_circle-02-24" transform="rotate(194.5664285714312 12 12)">
            <circle
              opacity="0.4"
              fill="none"
              stroke="#ffffff"
              stroke-miterlimit="10"
              cx="12"
              cy="12"
              r="11"
            />
            <path fill="none" stroke-miterlimit="10" d="M12,1 c6.0751324,0,11,4.9248676,11,11" stroke-linecap="butt" />
          </g>
          <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.5s" repeatCount="indefinite" />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import Plyr from 'plyr'
import axios from 'axios'

export default {
  data: () => ({
    player: null,
    assets: [],
    playerIndex: 0,
  }),
  mounted() {
    this.player = new Plyr(this.$refs.player, {
      autoplay: true,
      muted: true,
      captions: {
        active: true,
      },
    })
  },
  async created () {
    await this.getPlaylist()

    if (this.assets.length) {
      this.player.on('ended', () => {
        if (this.playerIndex >= this.assets.length) {
          this.playerIndex = 0
        } else {
          this.playerIndex++
        }
        this.playFromSource()
      })

      this.playFromSource()
    }
  },
  methods: {
    playFromSource () {
      this.player.source = this.assets[this.playerIndex]
      this.player.play()
    },
    async getPlaylist () {
      const response = await axios.get(this.route('current-playlist'))

      this.assets = response.data.data.map(asset => {
        return {
          type: 'video',
          title: asset.title,
          sources: [{
            src: asset.path,
            type: asset.mime_type,
            size: 720,
          }],
        }
      })
    },
  },
}
</script>

<style>
.plyr__captions {
  font-size: 42px;
}
</style>
